import { NEUTRAL_100 } from '@styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  overflow-y: auto;
`

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px 16px;
  margin: 16px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 16px;
`

export const DropdownWrapper = styled.div`
  width: 100%;
`

export const InputWrapper = styled.div`
  width: 100%;
`

export const KeyboardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`
